import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  DialogContentText,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";

function SignerDialog({ open, onClose, user_id, doc_id }) {
  const currentUser = useSelector((state) => state.authentication.user);
  console.log("currentUser", currentUser.data.firstname)
  const user= {
    id: currentUser.data.id,
    name: currentUser.data.firstname + " " + currentUser.data.lastname,
    email: currentUser.data.email
  }
  const [signers, setSigners] = useState([{
    id: currentUser.data.id,
    name: currentUser.data.firstname + " " + currentUser.data.lastname,
    email: currentUser.data.email
  }]);
  const [selectedSigner, setSelectedSigner] = useState("");
  const [openAddSignerModal, setOpenAddSignerModal] = useState(false);
  const [openEditSignerModal, setOpenEditSignerModal] = useState(false);
  const [currentSigner, setCurrentSigner] = useState(null);
  const [newSigner, setNewSigner] = useState({ name: "", email: "" });
  const [handleSignerData, setHandleSignerData] = useState(null);
  // Fetch signers when the dialog opens
  
  useEffect(() => {
    if (open) {
      fetchSigners();
    }
  }, [open]);

  const fetchSigners = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/prouser/get-all-signature-partners?user_id=${user_id}`
      );
      setSigners((prevSigners) => {
        const existingIds = prevSigners.map(signer => signer.id);
        const newSigners = response.data.data.filter(signer => !existingIds.includes(signer.id));
        return [...prevSigners, ...newSigners];
      });
      if (response.data.data.length > 0) {
        setSelectedSigner(response.data.data[0].name); // Default select first signer
      }
    } catch (error) {
      console.error("Error fetching signers:", error);
    }
  };

  const handleAddSigner = () => {
    setOpenAddSignerModal(true);
  };

  const handleSignerChange = (event) => {
    setSelectedSigner(event.target.value);
  };

  const handleAddNewSigner = async () => {
    if (newSigner.name && newSigner.email) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}api/prouser/add-signature-partner`,
          { ...newSigner, document_id: doc_id, user_id: user_id }
        );
        setSigners([...signers, response.data.data]);
        setOpenAddSignerModal(false);
        setNewSigner({ name: "", email: "" });
      } catch (error) {
        // toast.error("Error adding signer");
        console.error("Error adding signer:", error);
      }
    } else {
      console.error(
        "Please fill all fields",
      );
    }
  };

  const handleEditSigner = (signer) => {
    setCurrentSigner(signer);
    setOpenEditSignerModal(true);
  };

  const handleUpdateSigner = async () => {
    if (currentSigner) {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}api/prouser/update-signature-partner`,
          {...currentSigner, id: currentSigner.id}
        );
        const updatedSigners = signers.map((signer) =>
          signer.id === currentSigner.id ? currentSigner : signer
        );
        setSigners(updatedSigners);
        setOpenEditSignerModal(false);
      } catch (error) {
        console.error("Error updating signer:", error);
      }
    }
  };

  const handleDeleteSigner = async () => {
    if (currentSigner) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}api/prouser/delete-signature-partner/${currentSigner.id}`
        );
        const updatedSigners = signers.filter(
          (signer) => signer.id !== currentSigner.id
        );
        setSigners(updatedSigners);
        setOpenEditSignerModal(false);
        setOpenAddSignerModal(false)
      } catch (error) {
        console.error("Error deleting signer:", error);
      }
    }
  };

  return (
    <div>
      {/* Main Modal for selecting signer */}
      <Dialog open={openEditSignerModal || openAddSignerModal ? false : open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <strong>BusyPlace Sign</strong>
        </DialogTitle>
        <DialogContent>
          <h6 style={{ marginBottom: "10px" }}>Who will sign?</h6>
          <RadioGroup value={selectedSigner} onChange={handleSignerChange}>
            {signers.map((signer, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                mb={1}
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "5px",
                }}
                onClick={() => setHandleSignerData(signer)}
              >
                <FormControlLabel
                  value={signer.name}
                  control={
                    <Radio
                      sx={{
                        marginRight: "10px",
                        color:
                          selectedSigner === signer.name ? "green" : "default",
                        "&.Mui-checked": { color: "green" },
                      }}
                    />
                  }
                  label={signer.name}
                />
                <IconButton
                  onClick={() => handleEditSigner(signer)}
                  style={{ marginLeft: "10px" }}
                >
                  <SettingsIcon />
                </IconButton>
              </Box>
            ))}
          </RadioGroup>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            fullWidth
            onClick={handleAddSigner}
            style={{
              marginBottom: "10px",
              color: "green",
              borderColor: "green",
            }}
          >
            Add signer
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} style={{ color: "grey" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{ color: "white", backgroundColor: "green" }}
            onClick={()=>onClose(handleSignerData)}
          >
            Select
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Signer Modal */}
      <Dialog
        open={openAddSignerModal}
        onClose={() => setOpenAddSignerModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <IconButton onClick={() => setOpenAddSignerModal(false)} edge="start">
            <ArrowBackIcon />
          </IconButton>
          <strong>Add Signer</strong>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            fullWidth
            value={newSigner.name}
            onChange={(e) =>
              setNewSigner({ ...newSigner, name: e.target.value })
            }
            style={{ marginBottom: "15px" }}
          />
          <TextField
            label="Email address"
            fullWidth
            value={newSigner.email}
            onChange={(e) =>
              setNewSigner({ ...newSigner, email: e.target.value })
            }
            style={{ marginBottom: "15px" }}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleAddNewSigner}
          >
            Add
          </Button>
        </DialogContent>
      </Dialog>

      {/* Edit Signer Modal */}
      <Dialog
        open={openEditSignerModal}
        onClose={() => setOpenEditSignerModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <IconButton
            onClick={() => setOpenEditSignerModal(false)}
            edge="start"
          >
            <ArrowBackIcon />
          </IconButton>
          <strong>ROCKETSIGN - Edit Signer</strong>
        </DialogTitle>
        <DialogContent>
          {currentSigner && (
            <>
              <TextField
                label="Name"
                fullWidth
                value={currentSigner.name}
                onChange={(e) =>
                  setCurrentSigner({ ...currentSigner, name: e.target.value })
                }
                style={{ marginBottom: "15px" }}
              />
              <TextField
                label="Email address"
                fullWidth
                value={currentSigner.email}
                onChange={(e) =>
                  setCurrentSigner({ ...currentSigner, email: e.target.value })
                }
                style={{ marginBottom: "15px" }}
              />
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                startIcon={<DeleteIcon />}
                onClick={handleDeleteSigner}
                style={{ marginBottom: "15px" }}
              >
                Delete signer
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleUpdateSigner}
              >
                Done
              </Button>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default SignerDialog;
